import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICreateGroupResponse, IGroupState, IGroup } from "../../common/types/groupTypes";
import { createGroupUrl } from "../../config";
import { Status } from "../../common/constants";
import api from '../../api';

const CREATE_GROUP: string = "createGroup"

const initialState: IGroupState = {
  groups: [],
  status: null,
  error: null,
  reqId: null,
  msg: null
};

export const createGroup = createAsyncThunk(CREATE_GROUP, async (payload: IGroup, { rejectWithValue }) => {
    try {
      const response = await api.put<ICreateGroupResponse>(createGroupUrl, payload);
      const createGroupResponse: ICreateGroupResponse = response.data;
      return createGroupResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const createGroupSlice = createSlice({
  name: CREATE_GROUP,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createGroup.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(createGroup.fulfilled, (state, action) => {
        state.groups = [...state.groups, action.payload.data];
        state.msg = action.payload.message
        state.status = Status.SUCCESS
      })
      .addCase(createGroup.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
        state.reqId = Math.random()
        state.status = Status.FAILED
      });
  },
});

export default createGroupSlice.reducer;